<main class="esf-main-content esf-main-content--has-sidebar -has-transition" [class.-is-open]="sidebarService.isOpened">
  <div class="esf-container main-content">

    <div>
      <h1 class="esf-heading esf-heading--page esf-action-heading no-padding-top">
        <span class="esf-action-heading__text">
          <ng-container [ngSwitch]="customer.isCompany">
            <span *ngSwitchCase="false" class="private-customer"
                  i18n='Main heading for the customer profile component@@customerOverviewComponent.heading.customerProfile'>Customer profile</span>
            <span *ngSwitchCase="true" class="company-customer"
                  i18n='Main heading for the company profile component@@customerOverviewComponent.heading.companyProfile'>Company profile</span>
          </ng-container>

          <ng-container *ngIf="selectedClub.isCustomerScoreActive && !scoreLoading && customerScore">
            <button class="esf-button esf-button--simple" style="margin-left: 10px;" (click)="customerScoreModal.setModalStatus(true)">
              <svg class="esf-icon" width="24" height="24" *ngFor="let star of customerScore.earnedArray">
                <use xlink:href="#esf-icon-star"></use>
              </svg>
              <svg class="esf-icon" width="24" height="24" *ngFor="let star of customerScore.notEarnedArray">
                <use xlink:href="#esf-icon-star-outlined"></use>
              </svg>
            </button>
          </ng-container>

          <ng-container *ngIf="selectedClub.isCustomerScoreActive">
            <app-spinner style="margin-left: 10px;" [name]="'customerScoreSpinner'" [(show)]="scoreLoading" [display]="'inline'"></app-spinner>
          </ng-container>

          <span class="esf-tooltip esf-tooltip--right"
                *ngIf="!customer.synced"
                style="margin-left: 20px;"
                i18n-data-tooltip='Tooltip@@general.tooltip.customerDataOutOfSync'
                data-tooltip="Some customer data may be out of sync with TIXX">
            <svg class="esf-icon" style="color: #ffbf5f" width="36" height="36">
              <use xlink:href="#esf-icon-sync-off"></use>
            </svg>
          </span>
        </span>

        <span class="esf-action-heading__actions">
          <span class="esf-action-heading__action">
            <button class="esf-button esf-button--outlined esf-button--icon esf-button--icon-small"
                    [edsTooltip]="i18nGdprDisclosure"
                    (click)="showExportRequestModal()">
              <svg class="esf-icon" width="16" height="16">
                <use xlink:href="#esf-icon-document-text-info-16"></use>
              </svg>
            </button>
          </span>

          <span class="esf-action-heading__action" *ngIf="customer.state.status.value === 'locked'">
            <button class="esf-button esf-button--outlined esf-button--icon esf-button--icon-small"
                    [disabled]="!customer.hasTixxId"
                    [edsTooltip]="tooltipTranslations.i18nUnlockCustomer"
                    (click)="showUnlockingCustomerModal()">
              <svg class="esf-icon" width="16" height="16">
                <use xlink:href="#esf-icon-unlocked-16"></use>
              </svg>
            </button>
          </span>
          <span class="esf-action-heading__action" *ngIf="customer.state.status.value === 'active'">
            <button class="esf-button esf-button--outlined esf-button--icon esf-button--icon-small"
                    [disabled]="!customer.hasTixxId"
                    [edsTooltip]="tooltipTranslations.i18nLockCustomer"
                    (click)="lockCustomerModal.setModalStatus(true)">
              <svg class="esf-icon" width="16" height="16">
                <use xlink:href="#esf-icon-locked-16"></use>
              </svg>
            </button>
          </span>

          <ng-container *ngIf="authenticatedUser">
            <span class="esf-action-heading__action" *ngIf="authenticatedUser.isAdminType || authenticatedUser.isTicketAgent">
              <button class="esf-button esf-button--outlined esf-button--icon esf-button--icon-small"
                      [disabled]="customer.possibleDuplicateCount === 0 || !selectedClub.tixxCustomerMergeAllowed"
                      [edsTooltip]="tooltipTranslations.i18nPotentialDuplicates"
                      (click)="mergeCustomer()">
                <span [ngClass]="{'esf-badge': customer.possibleDuplicateCount !== 0}" [attr.data-badge]="customer.possibleDuplicateCount">
                  <svg class="esf-icon" width="16" height="16">
                    <use xlink:href="#esf-icon-people-two"></use>
                  </svg>
                </span>
              </button>
            </span>
          </ng-container>
          <span class="esf-action-heading__action" *ngIf="!selectedClub.isDataFeedActive">
            <button class="esf-button esf-button--filled esf-button--icon esf-button--icon-small"
                    (click)="tixxConnectionService.initiateTixxConnection(customer)"
                    [disabled]="!customer.canAccessTixx || !customer.hasTixxId"
                    [edsTooltip]="customer.state.status.value === 'locked' ? tooltipTranslations.i18nCustomerLocked : tooltipTranslations.i18nTicketing">
              <svg class="esf-icon" width="16" height="16">
                <use xlink:href="#esf-icon-ticket-small"></use>
              </svg>
            </button>
          </span>
        </span>
      </h1>

      <app-customer-duplicate-message
                                      *ngIf="customer.isDuplicate"
                                      (activateClicked)="activateCustomer()"
                                      (newEmailClicked)="duplicateEmailModal.setModalStatus(true)">
      </app-customer-duplicate-message>

      <div class="esf-info-tile-grid esf-info-tile-grid--3">
        <div app-customer-data-info
             class="esf-info-tile-grid__item customer-overview-box-wrap"
             style="display: flex; flex-direction: column; overflow: hidden;"
             [customer]="customer"
             [selectedClub]="selectedClub">
        </div>
        <div app-communication-data-info
             style="display: flex; flex-direction: column; overflow: hidden;"
             class="esf-info-tile-grid__item customer-overview-box-wrap"
             [spinnerName]="communicationDataSpinner">
        </div>
        <div app-attributes-info
             style="display: flex; flex-direction: column; overflow: hidden;"
             class="esf-info-tile-grid__item customer-overview-box-wrap"
             [customer]="customer">
        </div>
      </div>

      <div class="esf-accordion esf-accordion--info-tiles">

        <div class="esf-button-group esf-accordion__controls" buttonGroup [listOfPanels]="listOfPanels">
          <button class="esf-button esf-button--small esf-button-group__button"
                  (click)="setAllPanels(true)"
                  i18n="Action button@@general.button.openAllPanels">Open all panels</button>
          <button class="esf-button esf-button--small esf-button-group__button"
                  (click)="setAllPanels(false)"
                  i18n="Action button@@general.button.collapseAllPanels">Collapse all panels</button>
        </div>

        <app-address-list [customer]="customer"
                          [(isPanelOpened)]="listOfPanels.address">
        </app-address-list>

        <app-bank-data-list [customer]="customer"
                            [(isPanelOpened)]="listOfPanels.bankData">
        </app-bank-data-list>

        <app-crm-membership-list [customer]="customer"
                                 [(isPanelOpened)]="listOfPanels.membership"
                                 *ngIf="selectedClub?.isCrmMembershipActive">
        </app-crm-membership-list>

        <app-campai-membership-list [customer]="customer"
                                    [(isPanelOpened)]="listOfPanels.membership"
                                    *ngIf="selectedClub?.isCampaiMembershipActive">
        </app-campai-membership-list>

        <app-contact-management-list [customer]="customer"
                                     [(isPanelOpened)]="listOfPanels.lastContacts">
        </app-contact-management-list>

        <app-reminder-list [customer]="customer"
                           [(isPanelOpened)]="listOfPanels.reminders">
        </app-reminder-list>

        <app-merchandising-list [customer]="customer"
                                *ngIf="selectedClub?.isMerchandisingActive"
                                [(isPanelOpened)]="listOfPanels.merchandising">
        </app-merchandising-list>

        <app-ticketing [customer]="customer"
                       [(isPanelOpened)]="listOfPanels.ticketing">
        </app-ticketing>

        <app-tixx-select-list [customer]="customer"
                              *ngIf="selectedClub?.isLotteryActive"
                              [(isPanelOpened)]="listOfPanels.tixxSelectSubmissions">
        </app-tixx-select-list>

        <app-campaign-activity [customer]="customer"
                               [spinnerName]="communicationDataSpinner"
                               *ngIf="selectedClub?.isCampaignActive"
                               [(isPanelOpened)]="listOfPanels.campaignActivity">
        </app-campaign-activity>

        <app-activity-history [customer]="customer"
                              [(isPanelOpened)]="listOfPanels.history">
        </app-activity-history>
      </div>

    </div>
  </div>
</main>

<div class="esf-overlay esf-js-closeModal" [ngClass]="{'-is-open': customerOverviewService.deleteModal.deleteModalOpened}">
  <div class="esf-modal" [ngClass]="{'-is-open': customerOverviewService.deleteModal.deleteModalOpened}">
    <header class="esf-modal__header">
      <h3>
        <span class="space-after" i18n="General text@@deleteModal.header.deleteData">Delete data</span>
        <!-- <span>{{ customerOverviewService.deleteModal.deleteModalType }}</span> -->
      </h3>
    </header>
    <div class="esf-modal__inner">
      <div class="esf-text-block">
        <p i18n="General text@@deleteModal.paragraph.dataWillBeDeleted">The data will be deleted, this action cannot be undone and the data will be lost, Do you really want to delete this data? </p>
      </div>
    </div>
    <footer class="esf-modal__footer">
      <div class="esf-submit-row">
        <div class="esf-submit-row__item">
          <button class="esf-button esf-button--standard esf-button--filled" *ngIf="!customerOverviewService.loadingSubmitClicked"
                  (click)="deleteData(customerOverviewService.deleteModal.deleteModalId, customerOverviewService.deleteModal.deleteModalType)"
                  i18n="Action button@@general.button.yes"
                  [disabled]="!customer.isEditable">Yes</button>
          <div *ngIf="customerOverviewService.loadingSubmitClicked" class="esf-spinner flex-container">
            <div class="row">
              <span class="esf-spinner__bounce esf-spinner__bounce--1"></span>
              <span class="esf-spinner__bounce esf-spinner__bounce--2"></span>
              <span class="esf-spinner__bounce esf-spinner__bounce--3"></span>
            </div>
          </div>
        </div>
        <div class="esf-submit-row__item">
          <button class="esf-button esf-button--standard esf-button--outlined"
                  i18n="Action button@@general.button.back"
                  (click)="customerOverviewService.toggleDeleteModal(false)">Back</button>
        </div>
      </div>
    </footer>
    <div class="esf-modal__close" (click)="customerOverviewService.toggleDeleteModal(false)">
      <svg class="esf-icon esf-icon--darker" width="24" height="24">
        <use xlink:href="#esf-icon-close"></use>
      </svg>
    </div>
  </div>
</div>

<app-local-modal *ngIf="selectedClub.isCustomerScoreActive && customerScore"
                 #customerScoreModal
                 [showSubmitButton]="false"
                 [big]="true"
                 [title]="customerScoreName">
  <div class="customer-score-grid">
    <div class="customer-score-grid__item" *ngFor="let score of customerScore.earnedArray">
      <div class="esf-info-tile big-score">
        <div class="esf-info-tile__content">
          <div class="esf-customer-score-items">
            <button class="esf-button--simple" style="padding-right: calc((1rem + 1vw)/1.5); background-color: transparent;">
              <svg class="esf-icon " width="42" height="42">
                <use xlink:href="#esf-icon-star"></use>
              </svg>
            </button>
            <div>
              <div class="customer-score-name">{{ score.displayName }}</div>
              <div class="customer-score-description">{{ score.displayText }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="customer-score-grid">
    <div class="customer-score-grid__item" *ngFor="let score of customerScore.notEarnedArray">
      <div class="esf-info-tile small-score">
        <div class="esf-info-tile__content">
          <div class="esf-customer-score-items">
            <button class="esf-button--simple" style="padding-right: calc((1rem + 1vw)/1.5); background-color: transparent;">
              <svg class="esf-icon " width="26" height="26">
                <use xlink:href="#esf-icon-star-outlined"></use>
              </svg>
            </button>
            <div>
              <div class="customer-score-name__small">{{ score.displayName }}</div>
              <div class="customer-score-description__small">{{ score.displayText }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-local-modal>

<app-local-modal #lockCustomerModal
                 [title]="i18nLockCustomerTitle"
                 [submitDisabled]="updateCustomerLockedForm.invalid"
                 (submitClicked)="updateFormSubmit(updateCustomerLockedForm)">
  <form [formGroup]="updateCustomerLockedForm" id="updateCustomerLockedForm">

    <div app-form-field-select
         [control]="updateCustomerLockedForm.get('state.lockingReason.type')"
         [placeholderText]="flTranslations.i18nSelectReason"
         [label]="flTranslations.i18nCustomerLockingReason"
         [useNgValue]="true"
         [array]="lockingReasons">
    </div>

  </form>
</app-local-modal>

<app-local-modal #duplicateEmailModal
                 [title]="i18nDuplicateEmailTitle"
                 [submitDisabled]="!isEmailValid"
                 (submitClicked)="duplicateEmailFormSubmit(updateDuplicateEmailForm)">
  <form [formGroup]="updateDuplicateEmailForm" id="updateDuplicateEmailForm">

    <div app-form-field-email-checker
         [control]="updateDuplicateEmailForm.get('email')"
         [selectedClub]="selectedClub"
         (searchResultsEmpty)="isEmailValid = $event">
    </div>

  </form>
</app-local-modal>
